import { Item } from "$lib/components/ui/breadcrumb";
import { LineItemPrices, LineItem, LineItemProduct, ProductUnit, Model, LineItemLocation } from "./LineItem";

const categories = [
  'Cabinets',
  'Tables',
  'Chairs',
  'Sinks',
  'Refrigerators',
  'Ovens',
  'Microwaves',
  'Dishwashers',
  'Coffee Makers',
  'Toasters',
  'Blenders'
];

const descriptions = [
  'Kitchen Cabinet',
  'Dining Table',
  'Bar Stool',
  'Stainless Steel Sink',
  'BLANCO - Evier BLANCO, à encastrer, en Silgranit, BLANCOZENAR 5S, 1 cuve, 1 égt à gauche, vidage 90mm InFino auto et siphon, couleur gris rocher, planche à découper moyenne en frêne- garantie 10 ans',
  'Convection Oven',
  'Countertop Microwave',
  'Built-in Dishwasher',
  'Espresso Machine',
  '2-Slice Toaster',
  'High-Speed Blender'
];

function getRandomElement<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function generateRandomPrices(): LineItemPrices {
  const salesPriceExVat = parseFloat((Math.random() * 1000 + 50).toFixed(2));
  const vatPercent = 20;
  const vat = 20; //parseFloat((salesPriceExVat * vatPercent / 100).toFixed(2));
  
  const totalSalesPriceExVat = parseFloat((salesPriceExVat).toFixed(2));
  const totalSalesPriceIncVat = parseFloat((salesPriceExVat + vat).toFixed(2));

  const marginAmount = Math.random() * 2500 - 1250;
  let marginPercent = Math.random() * 50;
  if( marginAmount < 0 )
    marginPercent = -marginPercent;

  return {
    discountPercent: parseFloat((Math.random() * 30).toFixed(2)),
    pointPrice: parseFloat((Math.random() * 1000).toFixed(2)),
    costPriceExVat: parseFloat((salesPriceExVat * 0.8).toFixed(2)),
    salesPriceExVat,
    totalSalesPriceExVat,
    totalSalesPriceIncVat,
    vatAmount: vat,
    vatPercent,
    marginAmount,
    marginPercent
  };
}

function generateRandomLineItem(index: number): LineItem {
  const code = `UDacdaK5SI${index.toString().padStart(3, '0')}`;

  const unit: ProductUnit = {
        code: "pce",
        value: "pce"
    }
  const product: LineItemProduct = {
    code: `P${index.toString().padStart(3, '0')}`,
    mainCategory: getRandomElement(categories),
    description: getRandomElement(descriptions),
    unit: unit
  };

  const prices: LineItemPrices = generateRandomPrices();
  const quantity = Math.floor(Math.random() * 150) + 1;

  const id = index.toString();

  const model: Model = {
    catalog: {
      catalogName: 'Hacker / Concept'
    }
  }

  const location: LineItemLocation = {
    mainPos: 0,
    text: '1.2.1',
    subPos: 0,
    itemPos: 0
  }

  return {
    id,
    code,
    product,
    quantity,
    prices,
    model,
    location
  };
}

function generateLineItems(count: number): LineItem[] {
  const lineItems: LineItem[] = [];
  for (let i = 0; i < count; i++) {
    lineItems.push(generateRandomLineItem(i));
  }
  return lineItems;
}

const lineItems = generateLineItems(40);

// Exporter les données pour les utiliser dans un composant Svelte
export default lineItems;
